import React, { useState } from 'react';
import Quill from 'quill';
import TokenBlot from './quill/TokenBlot';
import { TOKEN_MODULE_NAME } from './quill/TokenDrop';
import { Button } from '@mui/material';
import QuillBetterTable from 'quill-better-table';
import { common } from 'constants/ImagesFiles';

const TOKEN_MATCHER = /\{\{(\w*)\|(\w*)\}\}/gi;

// Register custom font sizes with Quill
const Size = Quill.import('attributors/style/size');
Size.whitelist = [
  '10px',
  '12px',
  '12.5px',
  '13px',
  '13.5px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '28px',
  '32px',
  '36px',
];
Quill.register(Size, true);

const htmlToTokens = (htmlString) => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(htmlString, 'text/html');
  dom.querySelectorAll(`.${TokenBlot.className}`).forEach((token) => {
    const {
      dataset: { id, slug },
    } = token;
    token.replaceWith(`{{${slug}|${id}}}`);
  });
  return dom.body.innerHTML;
};

const tokensToHtml = (tokenizedString, tokensById) => {
  return tokenizedString.replace(TOKEN_MATCHER, (match, slug, id) => {
    const token = tokensById[id];
    if (!token) return match;
    const { title } = token;
    return `<${TokenBlot.tagName} class="${TokenBlot.className}" contenteditable="false" data-title="${title}" data-slug="${slug}" data-id="${id}">${title}</${TokenBlot.tagName}>`;
  });
};

const Editor = ({ value, onChange, quillRef, tokensById, id }) => {
  const [editor, setEditor] = useState(null);
  const tableModule = editor?.getModule('better-table');

  const CONFIG = {
    modules: {
      'better-table': {
        operationMenu: {
          items: {
            unmergeCells: {
              text: 'Another unmerge cells name',
            },
          },
        },
      },
      toolbar: {
        container: `#toolbar-${id}`,
      },
      [TOKEN_MODULE_NAME]: true,
      keyboard: {
        bindings: QuillBetterTable.keyboardBindings,
      },
    },
    theme: 'snow',
  };

  const onValueChange = (html) => onChange(htmlToTokens(html));

  const onMount = (container) => {
    if (!editor && container) {
      container.innerHTML = tokensToHtml(value, tokensById);
      const quill = new Quill(container, CONFIG);
      quill.on('text-change', () => onValueChange(quill.root.innerHTML));
      setEditor(quill);
      quillRef.current = quill;
    }
  };

  return (
    <div>
      <div id={`toolbar-${id}`} style={{ marginTop: 5, width: '21cm' }}>
        <span className="ql-formats" style={{ display: 'flex', gap: 10 }}>
          <select className="ql-header" defaultValue="3" style={{ width: 150 }}>
            <option value="1">Heading</option>
            <option value="2">Subheading</option>
            <option value="3">Normal Text</option>
            <option value="5">Small</option>
          </select>

          {/* Font Size Dropdown */}
          <select className="ql-size" defaultValue="14px" style={{ width: 80 }}>
            <option value="10px">10</option>
            <option value="12px">12</option>
            <option value="12.5px">12.5</option>
            <option value="13px">13</option>
            <option value="13.5px">13.5</option>
            <option value="14px">14</option>
            <option value="16px">16</option>
            <option value="18px">18</option>
            <option value="20px">20</option>
            <option value="24px">24</option>
            <option value="28px">28</option>
            <option value="32px">32</option>
            <option value="36px">36</option>
          </select>

          <Button variant="text" style={{ minWidth: 0 }} className="ql-bold" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-italic" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-underline" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-strike" />
          <select className="ql-align" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-list" value="ordered" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-list" value="bullet" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-indent" value="-1" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-indent" value="+1" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-link" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-image" />
          <Button variant="text" style={{ minWidth: 0 }} className="ql-video" />
          <Button
            style={{ minWidth: 0 }}
            onClick={() => {
              tableModule.insertTable(3, 3);
            }}
          >
            <img src={common.tableIcon} height={15} />
          </Button>
        </span>
      </div>
      <div ref={onMount} style={{ height: 500, width: '21cm' }} />
    </div>
  );
};

export default Editor;
